import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
interface CouponDetailModalProps {
  isOpen: boolean;
  onClose: () => void;
  coupon?: any;
}
export const CouponDetailModal: React.FC<CouponDetailModalProps> = ({
  isOpen,
  onClose,
  coupon
}) => {
  const [formData, setFormData] = useState({
    code: coupon?.code || '',
    services: coupon?.services ? [coupon.services] : ['All'],
    type: coupon?.type || 'Fixed Amount',
    discountAmount: coupon?.discount || '',
    proPercentage: coupon?.proPercentage || '0',
    realEstreamPercentage: coupon?.realEstreamPercentage || '100',
    limitDateRange: false,
    limitTotalRedemptions: false
  });
  if (!isOpen) return null;
  const handleInputChange = (field: string, value: any) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };
  const removeService = (service: string) => {
    setFormData(prev => ({
      ...prev,
      services: prev.services.filter(s => s !== service)
    }));
  };
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" data-id="element-98">
      <div className="bg-white rounded-lg w-full max-w-2xl max-h-[90vh] overflow-hidden flex flex-col" data-id="element-99">
        <div className="flex-1 overflow-y-auto p-6" data-id="element-100">
          <div className="space-y-6" data-id="element-101">
            <div data-id="element-102">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-103">
                <span className="text-red-500" data-id="element-104">*</span> Code
              </label>
              <input type="text" value={formData.code} onChange={e => handleInputChange('code', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500" placeholder="RAHAGENT" data-id="element-105" />
            </div>
            <div data-id="element-106">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-107">
                <span className="text-red-500" data-id="element-108">*</span> Services
              </label>
              <div className="flex flex-wrap gap-2" data-id="element-109">
                {formData.services.map(service => <span key={service} className="inline-flex items-center px-3 py-1 rounded bg-blue-500 text-white text-sm" data-id="element-110">
                    {service}
                    <button onClick={() => removeService(service)} className="ml-2 hover:bg-blue-600 rounded" data-id="element-111">
                      <XIcon size={14} data-id="element-112" />
                    </button>
                  </span>)}
              </div>
            </div>
            <div data-id="element-113">
              <label className="block text-sm font-medium text-gray-700 mb-3" data-id="element-114">
                <span className="text-red-500" data-id="element-115">*</span> Type
              </label>
              <div className="space-y-3" data-id="element-116">
                <label className="flex items-center space-x-3 cursor-pointer" data-id="element-117">
                  <input type="radio" name="type" value="Percentage" checked={formData.type === 'Percentage'} onChange={e => handleInputChange('type', e.target.value)} className="w-4 h-4 text-blue-600" data-id="element-118" />
                  <span className="text-sm text-gray-700" data-id="element-119">Percentage</span>
                </label>
                <label className="flex items-center space-x-3 cursor-pointer" data-id="element-120">
                  <input type="radio" name="type" value="Fixed Amount" checked={formData.type === 'Fixed Amount'} onChange={e => handleInputChange('type', e.target.value)} className="w-4 h-4 text-blue-600" data-id="element-121" />
                  <span className="text-sm text-gray-700" data-id="element-122">Fixed Amount</span>
                </label>
              </div>
            </div>
            <div data-id="element-123">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-124">
                <span className="text-red-500" data-id="element-125">*</span> Discount amount
              </label>
              <div className="relative" data-id="element-126">
                <input type="number" value={formData.discountAmount} onChange={e => handleInputChange('discountAmount', e.target.value)} className="w-full px-3 py-2 pr-10 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500" placeholder="25" data-id="element-127" />
                <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500" data-id="element-128">
                  $
                </span>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4" data-id="element-129">
              <div data-id="element-130">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-131">
                  <span className="text-red-500" data-id="element-132">*</span> Pro Percentage
                </label>
                <div className="relative" data-id="element-133">
                  <input type="number" value={formData.proPercentage} onChange={e => handleInputChange('proPercentage', e.target.value)} className="w-full px-3 py-2 pr-10 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500" placeholder="0" data-id="element-134" />
                  <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500" data-id="element-135">
                    %
                  </span>
                </div>
              </div>
              <div data-id="element-136">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-137">
                  Real Estream Percentage
                </label>
                <div className="relative" data-id="element-138">
                  <input type="number" value={formData.realEstreamPercentage} onChange={e => handleInputChange('realEstreamPercentage', e.target.value)} className="w-full px-3 py-2 pr-10 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500" placeholder="100" data-id="element-139" />
                  <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500" data-id="element-140">
                    %
                  </span>
                </div>
              </div>
            </div>
            <div data-id="element-141">
              <label className="block text-sm font-medium text-gray-700 mb-3" data-id="element-142">
                Redemption limites
              </label>
              <div className="space-y-3" data-id="element-143">
                <label className="flex items-start space-x-3 cursor-pointer" data-id="element-144">
                  <input type="checkbox" checked={formData.limitDateRange} onChange={e => handleInputChange('limitDateRange', e.target.checked)} className="w-4 h-4 mt-0.5 text-blue-600 rounded" data-id="element-145" />
                  <span className="text-sm text-gray-700" data-id="element-146">
                    Limit the date range when customers can redeem this coupon
                  </span>
                </label>
                <label className="flex items-start space-x-3 cursor-pointer" data-id="element-147">
                  <input type="checkbox" checked={formData.limitTotalRedemptions} onChange={e => handleInputChange('limitTotalRedemptions', e.target.checked)} className="w-4 h-4 mt-0.5 text-blue-600 rounded" data-id="element-148" />
                  <span className="text-sm text-gray-700" data-id="element-149">
                    Limit the total number of times this coupon can be redeemed
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="flex items-center justify-end px-6 py-4 border-t border-gray-200 bg-gray-50" data-id="element-150">
          <button onClick={onClose} className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 text-sm font-medium" data-id="element-151">
            Save
          </button>
        </div>
      </div>
    </div>;
};